import { createFileRoute } from "@tanstack/react-router";
import {
  breadcrumbJsonLd,
  buildHead,
  faqJsonLd,
  serviceJsonLd,
  webPageJsonLd,
} from "@/lib/seo";
import { alternatePath } from "@/lib/i18n";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { GEO_READINESS_FAQS } from "@/lib/geo-readiness-faqs";

const PATH = "/geo-readiness";
const TITLE = "GEO Readiness Audit: AI Visibility Evidence & Roadmap · Shugert";
const DESCRIPTION =
  "Evaluate technical access, entity evidence, citation surfaces, content clarity, structured data and competitive readiness. Receive a documented 90-day GEO roadmap without citation guarantees.";
const MODIFIED = "2026-08-19T00:00:00.000Z";

export const Route = createFileRoute("/geo-readiness")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "en",
      title: TITLE,
      description: DESCRIPTION,
      path: PATH,
      altPath: alternatePath(PATH, "es"),
      jsonLd: [
        webPageJsonLd({
          name: "GEO Readiness Audit: AI Visibility Evidence & Roadmap",
          path: PATH,
          description: DESCRIPTION,
          inLanguage: "en-US",
          dateModified: MODIFIED,
        }),
        serviceJsonLd({
          name: "GEO Readiness Audit",
          description:
            "A structured AI visibility diagnostic covering technical access, entity evidence, citation surfaces, content clarity, structured data and competitive readiness, with a prioritized 90-day roadmap.",
          path: PATH,
          serviceType: "GEO and AI Visibility Audit",
          locale: "en",
          deliverables: [
            "Six-dimension GEO assessment",
            "Citation-gap analysis",
            "Technical and content signal review",
            "Prioritized 90-day roadmap",
          ],
        }),
        breadcrumbJsonLd([
          { name: "Home", path: "/" },
          { name: "GEO Readiness Audit", path: PATH },
        ]),
        faqJsonLd([...GEO_READINESS_FAQS.en]),
      ],
    }),
});
